module.exports = __webpack_public_path__ + "static/img/net.1070955c.png";